/**
 * @fileoverview Componente responsável por exibir o cabeçalho e os metadados do ticket.
 */

import React from "react";

import { Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		height: 56,
		boxSizing: "border-box",
		background: theme.palette.type === 'dark'
			? 'linear-gradient(135deg, rgba(18, 18, 19, 0.95) 0%, rgba(22, 22, 24, 0.95) 100%)'
			: theme.palette.tabHeaderBackground,
		flex: "none",
		borderBottom: theme.palette.type === 'dark'
			? '1px solid rgba(91, 124, 255, 0.2)'
			: '1px solid rgba(0, 0, 0, 0.12)',
		'& > .MuiCardHeader-root': {
			flex: 1,
			minWidth: 0,
		},
		// O bloco do nome pode encolher (o TicketInfo corta só o texto do nome, com
		// reticências), em vez de invadir os botões da direita.
		'& .MuiCardHeader-content': {
			minWidth: 0,
		},
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			flexWrap: "wrap",
		},
	},
}));


const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card square className={classes.ticketHeader}>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
